import React, { useState, useCallback, useContext, createContext, useEffect } from 'react';

const ConfirmContext = createContext();

export function useConfirm() {
  return useContext(ConfirmContext);
}

export function ConfirmProvider({ children }) {
  const [state, setState] = useState(null);

  const confirm = useCallback((message, { confirmLabel = 'Confirm' } = {}) => {
    return new Promise((resolve) => {
      setState({ message, confirmLabel, resolve });
    });
  }, []);

  function handleResponse(result) {
    state?.resolve(result);
    setState(null);
  }

  useEffect(() => {
    if (!state) return;
    const handleEscape = (e) => { if (e.key === 'Escape') handleResponse(false); };
    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  });

  return (
    <ConfirmContext.Provider value={confirm}>
      {children}
      {state && (
        <div className="modal__overlay" onClick={() => handleResponse(false)}>
          <div className="modal__content" onClick={e => e.stopPropagation()} style={{ maxWidth: '400px' }}>
            <p style={{ fontSize: '15px', marginBottom: '20px', lineHeight: 1.5 }}>{state.message}</p>
            <div style={{ display: 'flex', gap: '8px' }}>
              <button className="btn btn--secondary" onClick={() => handleResponse(false)} style={{ flex: 1 }}>Cancel</button>
              <button className="btn btn--danger" onClick={() => handleResponse(true)} style={{ flex: 1 }}>{state.confirmLabel}</button>
            </div>
          </div>
        </div>
      )}
    </ConfirmContext.Provider>
  );
}
